import { FIELD_LOG_FOOTAGE_STATUS_MESSAGES } from '@/features/field-log/config/today';
import type { FieldLogFootageStatus } from '@/features/field-log/types/fieldLog';
import type { SupervisorTab } from '@/features/supervisor/types/supervisor';
import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

/** Tab ids remain stable URL values; each non-all tab maps to a link status. */
export const SUPERVISOR_TAB_FOOTAGE_STATUS = {
  new_video: 'review_match',
  no_video: 'link_manually',
} as const satisfies Record<Exclude<SupervisorTab, 'all'>, FieldLogFootageStatus>;

export const SUPERVISOR_ACTIVITY_TAB_LABELS: Record<SupervisorTab, MessageDescriptor> = {
  all: msg`All sessions`,
  new_video: FIELD_LOG_FOOTAGE_STATUS_MESSAGES.review_match,
  no_video: FIELD_LOG_FOOTAGE_STATUS_MESSAGES.link_manually,
};

export const SUPERVISOR_OPERATOR_PRESENCE_LABELS = {
  present: msg`Has operator`,
  missing: msg`Missing operator`,
} as const;
